import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    contracts: [],
    currentServiceContracts: [],
    filteredContracts : [],
    isLoading: false,
    isSerialSuccessfullyRecieved : false,
    shouldFetchContracts : true,
    selectedContractSerial: '',
    isAddContractDialogOpen: false,
    shouldFillFields: false,
    isConfirmationDialogOpen: false,
    currentLocation: '',
    currentAction: '',
    contractToDelete: 
    {
        contract: '',
        optional:'',
        description:'',
        service: '',
        
    }
    ,
    selectedContractInfo: {
        contract: '',
        description: '',
        logoPath:'',
        optional:'',
        service:''
    }
};

export const myContractsSlice = createSlice({
    name: 'myContracts',
    initialState,
    reducers:{
        setSelectedContractInfo : (state, action) => 
        {
            state.selectedContractInfo.contract = action.payload.contract
            state.selectedContractInfo.description = action.payload.description
            state.selectedContractInfo.optional = action.payload.optional
            state.selectedContractInfo.service = action.payload.service
        },
        setFilteredContracts: (state, action) =>
        {
            state.filteredContracts = action.payload
        },
        setContractToDelete : (state, action) => 
        {
            state.contractToDelete.contract = action.payload.contract
            state.contractToDelete.optional = action.payload.optional
            state.contractToDelete.description = action.payload.description
            state.contractToDelete.service = action.payload.service
            
        },
        setCurrentLocation : (state, action) => 
        {
            state.currentLocation = action.payload
        },
        setCurrentServiceContracts : (state, action) => 
        {
            state.currentServiceContracts = action.payload
        },
        setCurrentAction : (state, action) => 
        {
            state.currentAction = action.payload
        },
        changeConfirmationDialogState: (state) => 
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setConfirmationDialogState: (state, action) => 
        {
            state.isConfirmationDialogOpen = action.payload
        },
        setContracts: (state, action) => 
        {
            state.contracts = action.payload
        },
        setShouldFillFields: (state, action) => 
        {
            state.shouldFillFields = action.payload
        },
        setShouldFetchContracts: (state, action) => 
        {
            state.shouldFetchContracts = action.payload
        },
        resetContractSuccessfullyAdded : (state) => 
        {
            state.isContractSuccessfullyAdded = false
        },
        addContract : (state, action) => 
        {
            state.contracts = [...state.contracts, action.payload]
        },
        changeAddContractDialogState: (state) => 
        {
            state.isAddContractDialogOpen = !state.isAddContractDialogOpen
        },
        setAddContractDialogState: (state,action) => 
        {
            state.isAddContractDialogOpen = action.payload
        },
        setSelectedContractSerial : (state, action) => {
            state.selectedContractSerial = action.payload
            state.isSerialSuccessfullyRecieved = true
        },
        resetMyContractsState: (state) => 
        {
            state.contracts = []
            state.isLoading = false
            state.isContractSuccessfullyAdded = false
            state.isContractSuccessfullyRemoved = false
            state.isSerialSuccessfullyRecieved = false
            state.shouldFetchContracts = true
            state.isAddContractDialogOpen = false
            state.selectedContractSerial = ''
            state.isConfirmationDialogOpen = false
        },
        resetSelectedContractInfo: (state) => 
        {
            state.selectedContractInfo = {}
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'ListContracts')
                {         
                    state.contracts = action.payload.response.contractsList.map(contract => {return {logoPath:contract.logoPath,optional : contract.optional, contract: contract.contract , description: contract.description, service:contract.service}})  
                }
                else if(action.payload.endpoint === 'AddContract')
                {     
                    state.contracts = [...state.contracts, {optional : action.payload.request.optional, contract: action.payload.request.contract , description: action.payload.request.description, service: action.payload.request.service}]   
                    state.shouldFetchContracts = true                    
                    state.isAddContractDialogOpen = false
                }
                else if(action.payload.endpoint === 'InactivateContract')
                {         
                    state.contracts = state.contracts.filter(contract => contract.contract !== action.payload.request.contract)
                    state.shouldFetchContracts = true
                    state.isConfirmationDialogOpen = false
                }
            })
    },
})
export const { setService,setFilteredContracts, setContracts, resetContractSuccessfullyAdded,setConfirmationDialogState,setAddContractDialogState, setCurrentServiceContracts, setShouldFetchContracts, setContractToDelete, setCurrentLocation,setCurrentAction, changeConfirmationDialogState, addContract, changeAddContractDialogState, setShouldFillFields, setSelectedContractSerial, resetMyContractsState, resetMyContractsFlags, setSelectedContractInfo, resetSelectedContractInfo } = myContractsSlice.actions;

export const selectMyContractsState = (state) => state.myContracts;

export default myContractsSlice.reducer;

